import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box, LinearProgress } from '@mui/material';
import DialogContainer from '@shared/ui/dialog/DialogContainer';
import SignUpEmail from './SignUpEmail';
import SignUpPassword from './SignUpPassword';
import SignUpComplete from './SignUpComplete';
import SignUpValidate from './SignUpValidate';
import SignUpMarketplaces from './SignUpMarketplaces';

const SignUpFlow = () => {
  const location = useLocation();

  const getProgress = () => {
    switch (location.pathname.split('/').pop()) {
      case 'email':
        return 20;
      case 'validate':
        return 40;
      case 'password':
        return 60;
      case 'marketplaces':
        return 80;
      case 'complete':
        return 100;
      default:
        return 0;
    }
  };

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      bgcolor: 'background.default',
      p: 0
    }}>
      <DialogContainer maxWidth="600px" >
        <Box sx={{ position: 'relative', margin: 4 }}>

          <Box sx={{ textAlign: 'left', position: 'relative' }}>
            <img
              src="/assets/images/ic_just_stock.png"
              alt="JustStock Logo"
              style={{ height: 16 }}
            />

            <LinearProgress
              variant="determinate"
              value={getProgress()}
              sx={{
                position: 'relative',
                marginTop: 2,
                top: 0,
                left: 0,
                right: 0,
                height: 4,
                '& .MuiLinearProgress-bar': {
                  transition: 'transform 0.5s ease-in-out',
                },
              }}
            />
          </Box>
          <Box sx={{ pt: 3 }}>
            <Routes>
              <Route path="email" element={<SignUpEmail />} />
              <Route path="validate" element={<SignUpValidate />} />
              <Route path="password" element={<SignUpPassword />} />
              <Route path="marketplaces" element={<SignUpMarketplaces />} />
              <Route path="complete" element={<SignUpComplete />} />
              <Route path="*" element={<Navigate to="email" replace />} />
            </Routes>
          </Box>
        </Box>
      </DialogContainer>
    </Box>
  );
};

export default SignUpFlow; 